var React = require('react');

function Edit (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"id":"interactions","transform":"translate(-41.000000, -30.000000)"},React.createElement("g",{"id":"edit","transform":"translate(41.000000, 30.000000)"},[React.createElement("path",{"d":"M16.7736071,5.43733333 L18.5758929,3.56266667 C19.1058571,3.04166667 19.1058571,2.104 18.5758929,1.47933333 L17.515625,0.437333333 C16.9853214,-0.0833333333 16.03125,-0.0833333333 15.3950893,0.437333333 L13.5924643,2.20833333 L16.7736071,5.43733333 Z","id":"Fill-1","key":0}),React.createElement("polygon",{"points":"12.6383929 3.354 0.127232143 15.646 0.127232143 18.875 3.20217857 18.875 15.713 6.47933333","key":1})]))));
}

Edit.defaultProps = {"viewBox":"0 0 19 19","version":"1.1"};

module.exports = Edit;

Edit.default = Edit;
